import { render, staticRenderFns } from "./ExpedienteCreateApelacionView.vue?vue&type=template&id=1ab075f0&scoped=true&"
import script from "./ExpedienteCreateApelacionView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCreateApelacionView.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteCreateApelacionView.vue?vue&type=style&index=0&id=1ab075f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab075f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VDivider,
  VFlex,
  VIcon,
  VProgressCircular,
  VSpacer,
  VToolbar,
  VToolbarTitle,
  VTooltip,
})
